import React from 'react';
import { LoaderCircle } from 'lucide-react';

interface RouteLoadingStateProps {
  label: React.ReactNode;
  detail?: React.ReactNode;
  compact?: boolean;
}

const RouteLoadingState: React.FC<RouteLoadingStateProps> = ({ label, detail, compact = false }) => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    style={{
      minHeight: compact ? 132 : 'clamp(180px, 32vh, 280px)',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: compact ? '24px 16px' : '32px 20px',
      backgroundColor: 'var(--bg-secondary)',
      color: 'var(--text-secondary)',
      boxSizing: 'border-box',
    }}
  >
    <style>{`
      @keyframes xp-route-loading-spin {
        to { transform: rotate(360deg); }
      }
      @media (prefers-reduced-motion: reduce) {
        .xp-route-loading-spinner { animation-duration: 1.8s !important; }
      }
    `}</style>
    <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
      <LoaderCircle
        className="xp-route-loading-spinner"
        size={compact ? 24 : 30}
        strokeWidth={2}
        aria-hidden="true"
        style={{
          color: 'var(--primary-500)',
          marginBottom: 10,
          animation: 'xp-route-loading-spin 0.9s linear infinite',
        }}
      />
      <p style={{ margin: 0, fontSize: compact ? 13 : 14, fontWeight: 700, color: 'var(--text-primary)' }}>
        {label}
      </p>
      {detail ? (
        <p style={{ margin: '5px 0 0', fontSize: 12, lineHeight: 1.45, color: 'var(--text-tertiary)' }}>
          {detail}
        </p>
      ) : null}
    </div>
  </div>
);

export default RouteLoadingState;
